<template>
    <div class="page-title-wrapper">
        <div class="page-title">
            <Avatar class="lg squared float-left white"><svgicon name="directions" height="1.5rem" color="white"></svgicon></Avatar>
            <div class="page-titles-wrapper float-left">
                <div class="page-main-title">{{$t("wall.title")}}</div>
                <div class="page-sub-title">{{$t("wall.summary")}}</div>
            </div>
        </div>
        <div class="page-title-actions float-right">
            <slot name="page-title-actions" class="page-title-actions-inner"></slot>
        </div>
    </div>
</template>
<script>
    import Avatar from "../../components/Avatar/Avatar";

    export default {
        name: 'PageTitle',
        components: {
            Avatar
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./Pagetitle.scss" scoped lang="scss"></style>

